import { Box, Button, Flex, Heading, Link, Text } from "@chakra-ui/react";
import React from "react";
import "./ComparisonSet.scss";
import InfoIcon from "../../../components/Icons/InfoIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";

export default function ComparisonSet({ setModelRequestPeer }) {
  const navigate = useNavigate();
  const { loading: clientClusterWiseLoading, data: clientClusterWiseData } =
    useSelector((state) => state.clientClusterWiseReducer);
  console.log("----ComparisonSet", clientClusterWiseData);
  return (
    <Box className={"comparisonset_container"}>
      <Box margin={"5px 2px"}>
        <Flex justifyContent={"space-between"} padding={"5px"}>
          <Box padding={"5px 0px"}>
            <Text className={"heading-label"}>Comparison set</Text>
          </Box>
          <Flex>
            <Flex padding={"5px 0px"}>
              <Box padding={"4px"}>
                <InfoIcon />
              </Box>
              <Text className={"heading-label-v1"}>Peer Missing?</Text>
            </Flex>
            <Box marginLeft={"5px"}>
              <Button
                height={"30px"}
                border={"1px solid black"}
                color={"#5D5D5D"}
                fontSize={"14px"}
                fontWeight={"600"}
                backgroundColor={"white"}
                onClick={() => setModelRequestPeer(true)}
              >
                Request for peer
              </Button>
            </Box>
          </Flex>
        </Flex>
        <Box backgroundColor={"#E6E6E6"} borderRadius={"4px"}>
          {clientClusterWiseLoading ? (
            <Loader />
          ) : (
            <Flex flexWrap={"wrap"} padding={"5px"}>
              {clientClusterWiseData?.clusterWiseData.map((client, idx) => (
                <Flex className="peer-block" justifyContent={"space-between"}>
                  <Box>
                    {idx + 1}. {client?.companyName}
                  </Box>
                  <Box
                    marginLeft={"10px"}
                    cursor={"pointer"}
                    // onClick={() => {
                    //   navigate(`/client/${client.id}/competitive-risks`);
                    // }}
                  >
                    <Link
                      href={`${client.companyWebsite}`}
                      isExternal
                      color="teal.500"
                    >
                      <ViewIcon />
                    </Link>
                  </Box>
                </Flex>
              ))}
            </Flex>
          )}
        </Box>
      </Box>
    </Box>
  );
}
